<template>
  <b-card no-body class="mb-1" v-if="currentUser.info.role_id === 3 || currentUser.info.role_id === 4 || currentUser.info.role_id === 6">
    <b-card-header header-tag="header" class="p-3" role="tab">
      <span class="m-1">Akun Bank</span>
      <b-button v-b-toggle.accordion-7 variant="yellow" class="chevron">
        <span class="when-open">
          <b-icon icon="chevron-up" />
        </span>
        <span class="when-closed">
          <b-icon icon="chevron-down" />
        </span>
      </b-button>
    </b-card-header>

    <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <b-card-text>
          <div class="container">
            <b-alert v-if="sectionRejectionMessages.length > 0" show variant="warning" class="mb-4 alert-soft-warning">
              <b-icon icon="exclamation-triangle-fill" class="mr-2"></b-icon>
              <strong>Berdasarkan hasil verifikasi, pengajuan saat ini belum dapat disetujui.</strong>
              <div v-for="(msg, idx) in sectionRejectionMessages" :key="idx" class="mt-2 ml-4">
                <p class="mb-1"><strong>Alasan:</strong> {{ msg.note }}</p>
                <div v-if="msg.fields && msg.fields.length > 0">
                  <p class="mb-0"><strong>Data atau informasi yang memerlukan perbaikan (Akun Bank):</strong></p>
                  <ol class="mb-2">
                  <li v-for="f in msg.fields" :key="f.field" class="font-weight-bold">{{ f.label }}</li>
                  </ol>
                </div>
              </div>
              <hr v-if="sectionRejectionMessages.length > 0">
              <p class="mt-2 mb-0">Untuk dapat melakukan pengajuan kembali mohon dapat memperbarui akun bank anda pada kolom yang berwarna merah di bawah ini.</p>
            </b-alert>

            <b-form @submit.prevent="saveBankAccount">
              <div class="row">
                <span style="font-size: 12px;">Note : (*) Wajib diisi</span>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="bank_name" :class="{'text-danger font-weight-bold': allRejectedFields.includes('bank_id')}">Nama Bank *</label>
                    <v-select 
                      v-model="bankAccount.bank_id" 
                      :options="bankOptions" 
                      :reduce="bank => bank.value" 
                      label="text"
                      placeholder="Pilih bank..."
                      :class="{'is-invalid-vselect border-danger': allRejectedFields.includes('bank_id')}"
                      required
                    ></v-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="account_number" :class="{'text-danger font-weight-bold': allRejectedFields.includes('account_number')}">Nomor Rekening *</label>
                    <b-form-input v-model="bankAccount.account_number" placeholder="Masukkan nomor rekening" :class="{'is-invalid border-danger': allRejectedFields.includes('account_number')}"></b-form-input>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="account_name" :class="{'text-danger font-weight-bold': allRejectedFields.includes('account_name')}">Nama Pemilik Rekening *</label>
                    <b-form-input v-model="bankAccount.account_name" placeholder="Masukkan nama pemilik rekening" :class="{'is-invalid border-danger': allRejectedFields.includes('account_name')}"></b-form-input>
                  </div>
                </div>
              </div>

              <div class="mt-4 mb-3">
                <b-button
                  type="submit"
                  variant="primary"
                  :disabled="hasUnresolvedSectionRejection"
                  :title="hasUnresolvedSectionRejection ? 'Perbaiki semua data yang ditolak terlebih dahulu' : ''"
                >Simpan Akun Bank</b-button>
              </div>
            </b-form>
          </div>

          <!-- Modal konfirmasi -->
          <b-modal size="sm" v-model="confirmModal" hide-footer hide-header>
            <div class="d-block text-center">
              <h3>Apakah Anda yakin ingin menyimpan data ini?</h3>
            </div>
            <div class="row">
              <div class="col">
                <b-button class="mt-3" block @click="confirmSaveBankAccount">Ya</b-button>
              </div>
              <div class="col">
                <b-button class="mt-3" block @click="confirmModal = false">Tidak</b-button>
              </div>
            </div>
          </b-modal>

          <!-- Modal sukses -->
          <b-modal size="sm" v-model="successModal" hide-footer hide-header>
            <div class="d-block text-center">
              <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
              <h3>Data akun bank berhasil disimpan!</h3>
            </div>
            <div class="row">
              <div class="col">
                <b-button class="mt-3" block @click="successModal = false">Tutup</b-button>
              </div>
            </div>
          </b-modal>

          <b-modal size="sm" v-model="errorModal" hide-footer hide-header>
            <div class="d-block text-center">
              <b-icon 
                icon="x-circle" 
                animation="throb" 
                variant="danger" 
                style="width: 120px; height: 120px;">
              </b-icon>
              <h3>Data akun bank gagal disimpan!</h3>
            </div>
            <div class="row">
              <div class="col">
                <b-button class="mt-3" block variant="danger" @click="errorModal = false">
                  Tutup
                </b-button>
              </div>
            </div>
          </b-modal>
        </b-card-text>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>


<script>
import JenisBank from "../../api/jenisbank";
import UserBank from "../../api/userbank";

export default {
  name: "AkunBank",
  props: {
    allRejectedFields: {
      type: Array,
      default: () => []
    },
    rejectionMessages: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      bankAccount: {
        id: null,
        bank_id: null,
        account_number: "",
        account_name: "",
      },
      originalBankAccount: {},
      bankOptions: [],
      confirmModal: false,
      successModal: false,
      errorModal: false,
      loadingData: false,
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    bankAccount: {
      handler(newVal) {
        if (this.loadingData || !this.originalBankAccount) return;
        this.allRejectedFields.forEach(field => {
          if (newVal[field] !== this.originalBankAccount[field]) {
            this.$emit('dirty', field);
          }
        });
      },
      deep: true
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    hasUnresolvedSectionRejection() {
      return this.sectionRejectionMessages.some(msg => msg.fields && msg.fields.length > 0);
    },
    sectionRejectionMessages() {
      if (!this.rejectionMessages) return [];
      
      return this.rejectionMessages.map(msg => {
        const filteredFields = msg.fields ? msg.fields.filter(f => {
          const model = (f.model || '').trim().toLowerCase();
          return model === 'userbank';
        }) : [];

        if (filteredFields.length > 0) {
          return {
            note: msg.note,
            fields: filteredFields
          };
        }
        return null;
      }).filter(msg => msg !== null);
    }
  },
  methods: {
    loadData() {
      this.loadingData = true;
      UserBank.me()
        .then((res) => {
          this.bankAccount.id = res.data.data.id;

          if (res.data.data.bank_id) {
            this.bankAccount.bank_id = res.data.data.bank_id;
          }
          if (res.data.data.account_number) {
            this.bankAccount.account_number = res.data.data.account_number;
          }
          if (res.data.data.account_name) {
            this.bankAccount.account_name = res.data.data.account_name;
          }
          
          this.originalBankAccount = JSON.parse(JSON.stringify(this.bankAccount || {}));
          this.loadingData = false;

          JenisBank.index()
            .then((res) => {
              // console.log(res);
              this.bankOptions = res.data.data.map(bank => ({
                value: bank.id,
                text: bank.name
              }));
            })
            .catch((err) => console.error(err));
        })
        .catch(err => {
          console.error(err);
          this.loadingData = false;
        });
    },
    saveBankAccount() {
      this.confirmModal = true;
    },
    confirmSaveBankAccount() {
      UserBank.update(this.bankAccount)
        .then(res => {
          if (res.data.meta.code === 200 || res.data.meta.code === 201) {
            this.successModal = true;
            this.confirmModal = false;
            this.$emit('updated');
          } else {
            this.errorModal = true;
            this.confirmModal = false;
          }
        })
        .catch(err => {
          console.error(err);
          this.confirmModal = false;
        });
    }
  }
};
</script>


<style scoped>
.collapsed>.when-open,
.not-collapsed>.when-closed {
  display: none;
}
.is-invalid-vselect >>> .vs__dropdown-toggle {
  border-color: #e08080 !important;
  border-width: 1px !important;
}
.form-control.is-invalid,
.form-control.border-danger {
  border-color: #e08080 !important;
  border-width: 1px !important;
  box-shadow: none !important;
}
.alert-soft-warning {
  background-color: #fff8ec !important;
  border-color: #f5c97a !important;
  color: #7a5c1e !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pengajuan-saya/AkunBank.vue